import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { PERFORM_APPLICATION_ACTION } from '@applicant-flow/graphql/mutations';

export default function PerformApplicationActionButton({
  application,
  state,
  children,
  reason,
}) {
  function errorMessage() {
    createMessage(
      'error',
      'Failed to change application state. Please try again.'
    );
  }

  const [performAction, { loading }] = useMutation(PERFORM_APPLICATION_ACTION, {
    onCompleted: (data) => {
      if (data.performApplicationAction.error) {
        errorMessage();
        return;
      }

      createMessage('success', 'Application status successfully changed');
    },
    onError: errorMessage,
  });

  const changeApplicationState = () => {
    performAction({
      variables: {
        staffingRequestApplicationId: application.id,
        input: {
          action: state,
          reason: reason,
        },
      },
    });
  };

  if (state === 'reject') {
    return <span onClick={changeApplicationState}>{children}</span>;
  }

  return (
    <Button type="primary" onClick={changeApplicationState} loading={loading}>
      {children}
    </Button>
  );
}

PerformApplicationActionButton.propTypes = {
  state: PropTypes.string.isRequired,
  application: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  children: PropTypes.node.isRequired,
  reason: PropTypes.string,
};
